var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg07Diamond03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "1600px",
    height: "1600px",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 160000 160000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "FontID0",
    horizAdvX: 834,
    fontVariant: "normal",
    fillRule: "nonzero",
    fontWeight: 900
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Gordita Ultra"
  }, /*#__PURE__*/React.createElement("fontFaceSrc", null, /*#__PURE__*/React.createElement("fontFaceName", {
    name: "Gordita-Ultra"
  }))), /*#__PURE__*/React.createElement("missingGlyph", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0z"
  })), /*#__PURE__*/React.createElement("glyph", {
    unicode: 3,
    horizAdvX: 685,
    d: "M267.004 305.007l58.0054 0c56.0034,0 84.0051,-21.0035 84.0051,-64.0026 0,-39.9961 -36.0009,-60.9996 -84.0051,-60.9996 -50.0062,0 -88.0003,27.0007 -114,80.0011l-183.008 -91.0033c22.9966,-60.9996 63.0016,-106.001 118.004,-136.004 55.0024,-29.9949 118.004,-45.0011 189.005,-45.0011 85.9983,0 158,21.0035 217.007,63.0016 58.9976,43.008 88.0003,101.005 88.0003,175.008 0,84.9972 -42.9991,145.005 -128.005,180.005 76.0059,33.9989 114.009,90.0023 114.009,168.001 0,65.0036 -27.0007,118.004 -81.0021,159.01 -54.0102,41.9981 -124.01,63.0016 -211.009,63.0016 -67.0056,0 -128.005,-15.0063 -183.008,-45.0011 -54.0014,-30.0037 -92.0043,-74.0039 -112.999,-133.01l184 -89.0013c21.0035,47.0032 59.0064,75.0049 100.004,75.0049 101.005,6.99821 99.0025,-125.002 0,-118.004l-55.0024 0 0 -181.006z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_07_Diamond_03.svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "ARC_1_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    d: "M92149 155958c41950,-6710 70518,-46157 63809,-88107 -6710,-41950 -46157,-70518 -88107,-63809 -41950,6710 -70518,46157 -63809,88107 5250,32822 30987,58559 63809,63809"
  })), /*#__PURE__*/React.createElement("g", {
    id: "CIRCLE_1_"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    cx: 80000,
    cy: 80000,
    r: 80000
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_49_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    d: "M72308 138462l15384 0c4249,0 7693,3444 7693,7692 0,4248 -3444,7692 -7693,7692l-15384 0c-4249,0 -7693,-3444 -7693,-7692 0,-4248 3444,-7692 7693,-7692z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_48_"
  }, /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "61695,147986 59652,149299 49604,127297 25416,127297 28859,103355 8511,90279 24350,71999 14302,49997 37510,43182 40953,19241 64160,26055 80000,7775 95840,26055 119047,19241 122490,43182 145698,49997 135650,71999 151489,90279 131141,103355 134584,127297 110396,127297 100348,149299 98305,147986 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_47_"
  }, /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "62692,151003 58328,153807 47627,130374 21865,130374 25532,104875 3860,90947 20730,71478 10028,48045 34746,40787 38412,15288 63130,22546 80000,3077 96870,22546 121588,15288 125254,40787 149972,48045 139270,71478 156140,90947 134468,104875 138135,130374 112373,130374 101672,153807 97308,151003 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_46_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    d: "M67851 155958c-2234,-1016 -4054,-2764 -5159,-4955"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_45_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    d: "M61695 147986c-104,-605 -157,-1218 -157,-1832 0,-5948 4822,-10769 10770,-10769"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_44_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    d: "M72308 135385l15384 0c614,0 1227,52 1832,157 5861,1011 9792,6583 8781,12444"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_43_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    d: "M97308 151003c-1105,2191 -2925,3939 -5159,4955"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_42_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "52021,48848 42694,65002 61347,65002 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_41_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "52021,50387 44027,64233 60015,64233 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_40_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "61347,65002 70674,48848 52021,48848 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_39_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "61347,63463 69341,49617 53353,49617 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_38_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "70674,48848 61347,65002 80000,65002 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_37_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "70674,50387 62679,64233 78668,64233 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_36_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "80000,65002 89326,48848 70674,48848 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_35_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "80000,63463 87994,49617 72006,49617 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_34_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "89326,48848 80000,65002 98653,65002 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_33_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "89326,50387 81332,64233 97321,64233 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_32_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "98653,65002 107979,48848 89326,48848 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_31_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "98653,63463 106647,49617 90659,49617 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_30_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "107979,48848 98653,65002 117306,65002 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_29_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "107979,50387 99985,64233 115973,64233 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "LINE_9_"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    x1: 80000,
    y1: 118462,
    x2: 42694,
    y2: 65002
  })), /*#__PURE__*/React.createElement("g", {
    id: "LINE_8_"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    x1: 80000,
    y1: 118462,
    x2: 61347,
    y2: 65002
  })), /*#__PURE__*/React.createElement("g", {
    id: "LINE_7_"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    x1: 80000,
    y1: 118462,
    x2: 98653,
    y2: 65002
  })), /*#__PURE__*/React.createElement("g", {
    id: "LINE_6_"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    x1: 80000,
    y1: 118462,
    x2: 117306,
    y2: 65002
  })), /*#__PURE__*/React.createElement("g", {
    id: "LINE_5_"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    x1: 80000,
    y1: 118462,
    x2: 80000,
    y2: 65002
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_28_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "77433,113438 44169,65771 60801,65771 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_27_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "79231,65771 79231,113922 62430,65771 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_26_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "82567,113438 115831,65771 99199,65771 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_25_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "80769,65771 80769,113922 97570,65771 "
  })))), /*#__PURE__*/React.createElement("text", {
    x: 75547,
    y: 150827,
    fill: "black",
    fontWeight: 900,
    fontSize: "13333px",
    fontFamily: "Gordita Ultra"
  }, "3"), /*#__PURE__*/React.createElement("path", {
    fill: "#1B0921",
    d: "M87692 135385c614,0 1227,52 1832,157 5861,1011 9792,6583 8781,12444l2043 1313 10048 -22002 24188 0 -3443 -23942 20348 -13076 -15839 -18280 10048 -22002 -23208 -6815 -3443 -23941 -23207 6814 -15840 -18280 -15840 18280 -23207 -6814 -3443 23941 -23208 6815 10048 22002 -15839 18280 20348 13076 -3443 23942 24188 0 10048 22002 2043 -1313c-104,-605 -157,-1218 -157,-1832 0,-5948 4822,-10769 10770,-10769l15384 0zm29614 -70383l-37306 53460 -37306 -53460 9327 -16154 18653 0 18652 0 18653 0 9327 16154z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B0921",
    d: "M95385 146154c0,-4248 -3444,-7692 -7693,-7692l-15384 0c-4249,0 -7693,3444 -7693,7692 0,4248 3444,7692 7693,7692l15384 0c4249,0 7693,-3444 7693,-7692zm-13012 -741c1134,467 1707,1267 1707,2400 0,987 -387,1760 -1173,2334 -787,560 -1747,840 -2894,840 -946,0 -1786,-200 -2520,-600 -733,-400 -1266,-1000 -1573,-1814l2440 -1213c347,707 853,1067 1520,1067 640,0 1120,-280 1120,-814 0,-573 -373,-853 -1120,-853l-773 0 0 -2413 733 0c1320,93 1347,-1667 0,-1574 -547,0 -1053,374 -1333,1000l-2454 -1186c280,-787 787,-1374 1507,-1774 733,-400 1547,-600 2440,-600 1160,0 2093,280 2813,840 720,547 1080,1254 1080,2120 0,1040 -506,1787 -1520,2240z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    stroke: "#7D6612",
    strokeWidth: 400,
    strokeMiterlimit: 22.9256,
    d: "M84080 147813c0,-1133 -573,-1933 -1707,-2400 1014,-453 1520,-1200 1520,-2240 0,-866 -360,-1573 -1080,-2120 -720,-560 -1653,-840 -2813,-840 -893,0 -1707,200 -2440,600 -720,400 -1227,987 -1507,1774l2454 1186c280,-626 786,-1000 1333,-1000 1347,-93 1320,1667 0,1574l-733 0 0 2413 773 0c747,0 1120,280 1120,853 0,534 -480,814 -1120,814 -667,0 -1173,-360 -1520,-1067l-2440 1213c307,814 840,1414 1573,1814 734,400 1574,600 2520,600 1147,0 2107,-280 2894,-840 786,-574 1173,-1347 1173,-2334z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082187",
    stroke: "#0C709E",
    strokeWidth: 400,
    strokeMiterlimit: 22.9256,
    d: "M52021 50387l7994 13846 -15988 0 7994 -13846zm-9327 14615l18653 0 -9326 -16154 -9327 16154z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082187",
    stroke: "#0C709E",
    strokeWidth: 400,
    strokeMiterlimit: 22.9256,
    d: "M52021 48848l9326 16154 9327 -16154 -18653 0zm9326 14615l-7994 -13846 15988 0 -7994 13846z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082187",
    stroke: "#0C709E",
    strokeWidth: 400,
    strokeMiterlimit: 22.9256,
    d: "M61347 65002l-18653 0 37306 53460 -18653 -53460zm-546 769l16632 47667 -33264 -47667 16632 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082187",
    stroke: "#0C709E",
    strokeWidth: 400,
    strokeMiterlimit: 22.9256,
    d: "M61347 65002l18653 53460 0 -53460 -18653 0zm17884 48920l-16801 -48151 16801 0 0 48151z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082187",
    stroke: "#0C709E",
    strokeWidth: 400,
    strokeMiterlimit: 22.9256,
    d: "M61347 65002l18653 0 -9326 -16154 -9327 16154zm1332 -769l7995 -13846 7994 13846 -15989 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082187",
    stroke: "#0C709E",
    strokeWidth: 400,
    strokeMiterlimit: 22.9256,
    d: "M80000 65002l0 53460 18653 -53460 -18653 0zm769 48920l0 -48151 16801 0 -16801 48151z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082187",
    stroke: "#0C709E",
    strokeWidth: 400,
    strokeMiterlimit: 22.9256,
    d: "M80000 65002l18653 0 -9327 -16154 -9326 16154zm1332 -769l7994 -13846 7995 13846 -15989 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082187",
    stroke: "#0C709E",
    strokeWidth: 400,
    strokeMiterlimit: 22.9256,
    d: "M80000 65002l9326 -16154 -18652 0 9326 16154zm0 -1539l-7994 -13846 15988 0 -7994 13846z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082187",
    stroke: "#0C709E",
    strokeWidth: 400,
    strokeMiterlimit: 22.9256,
    d: "M89326 48848l9327 16154 9326 -16154 -18653 0zm17321 769l-7994 13846 -7994 -13846 15988 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082187",
    stroke: "#0C709E",
    strokeWidth: 400,
    strokeMiterlimit: 22.9256,
    d: "M107979 48848l-9326 16154 18653 0 -9327 -16154zm7994 15385l-15988 0 7994 -13846 7994 13846z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082187",
    stroke: "#0C709E",
    strokeWidth: 400,
    strokeMiterlimit: 22.9256,
    d: "M117306 65002l-18653 0 -18653 53460 37306 -53460zm-34739 48436l16632 -47667 16632 0 -33264 47667z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F0F0F0",
    points: "60015,64233 52021,50387 44027,64233 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F0F0F0",
    points: "60801,65771 44169,65771 77433,113438 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F0F0F0",
    points: "62430,65771 79231,113922 79231,65771 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F0F0F0",
    points: "62679,64233 78668,64233 70674,50387 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F0F0F0",
    points: "61347,63463 69341,49617 53353,49617 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F0F0F0",
    points: "72006,49617 80000,63463 87994,49617 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F0F0F0",
    points: "97570,65771 80769,65771 80769,113922 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F0F0F0",
    points: "81332,64233 97321,64233 89326,50387 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F0F0F0",
    points: "90659,49617 98653,63463 106647,49617 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F0F0F0",
    points: "99199,65771 82567,113438 115831,65771 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F0F0F0",
    points: "99985,64233 115973,64233 107979,50387 "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8933D4",
    d: "M63130 22546l16870 -19469 16870 19469 24718 -7259c-15363,-9880 -34281,-14357 -53737,-11245 -41549,6646 -69971,45406 -63991,86905l16870 -19469 -10702 -23433 24718 -7258 3666 -25499 24718 7258z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8933D4",
    d: "M121588 15288l3666 25499 24718 7258 -10702 23433 16870 19469 -21672 13928 3667 25499 -25762 0 -10701 23433 -4364 -2804c-1105,2191 -2925,3939 -5159,4955 41950,-6710 70518,-46157 63809,-88107 -3598,-22494 -16608,-41140 -34370,-52563z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8933D4",
    d: "M58328 153807l-10701 -23433 -25762 0c11573,13352 27678,22655 45986,25584 -2234,-1016 -4054,-2764 -5159,-4955l-4364 2804z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8933D4",
    d: "M21865 130374l3667 -25499 -21672 -13928c57,401 118,801 182,1202 2322,14513 8649,27641 17823,38225z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#270545",
    stroke: "#0B0F8A",
    strokeWidth: 1200,
    strokeMiterlimit: 22.9256,
    d: "M121588 15287c17762,11424 30772,30070 34370,52564 6709,41950 -21859,81397 -63809,88107 2234,-1016 4054,-2764 5159,-4955l4364 2804 10701 -23433 25762 0 -3667 -25499 21672 -13928 -16870 -19469 10702 -23433 -24718 -7258 -3666 -25500zm-117728 75660c-5980,-41499 22442,-80259 63991,-86905 19456,-3112 38374,1365 53737,11245l-24718 7259 -16870 -19469 -16870 19469 -24718 -7258 -3666 25499 -24718 7258 10702 23433 -16870 19469zm4651 -668l15839 -18280 -10048 -22002 23208 -6815 3443 -23941 23207 6814 15840 -18280 15840 18280 23207 -6814 3443 23941 23208 6815 -10048 22002 15839 18280 -20348 13076 3443 23942 -24188 0 -10048 22002 -2043 -1313c1011,-5861 -2920,-11433 -8781,-12444 -605,-105 -1218,-157 -1832,-157l-15384 0c-5948,0 -10770,4821 -10770,10769 0,614 53,1227 157,1832l-2043 1313 -10048 -22002 -24188 0 3443 -23942 -20348 -13076zm13354 40095c-9174,-10584 -15501,-23712 -17823,-38225 -64,-401 -125,-801 -182,-1202l21672 13928 -3667 25499zm42750 15780c0,-4248 3444,-7692 7693,-7692l15384 0c4249,0 7693,3444 7693,7692 0,4248 -3444,7692 -7693,7692l-15384 0c-4249,0 -7693,-3444 -7693,-7692zm95385 -66154c0,-44183 -35817,-80000 -80000,-80000 -44183,0 -80000,35817 -80000,80000 0,44183 35817,80000 80000,80000 44183,0 80000,-35817 80000,-80000zm-138135 50374l25762 0 10701 23433 4364 -2804c1105,2191 2925,3939 5159,4955 -18308,-2929 -34413,-12232 -45986,-25584z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg07Diamond03);
export default __webpack_public_path__ + "static/media/07_Diamond_03.0ceec153fbb1dbacedc71e2203aa2acf.svg";
export { ForwardRef as ReactComponent };